'use client';

import { FC } from 'react';

import Script from 'next/script';

import { useIsWebView } from '@telialt/utils/src/useIsWebView/useIsWebView';

export const VendorScripts: FC = () => {
    const isWebView = useIsWebView();

    return (
        <>
            <Script src="https://r422.telia.lt/script.js" />
            <Script
                id="optimizely-script"
                type="text/plain"
                className="optanon-category-C0003"
                src="https://optimizely.teliacompany.com/cdn/js/28360350207.js"
            />
            <Script id="optimizely-enabling">
                {`
                    (function() {
                        var optimizelyScript = document.getElementById('optimizely-script');
                        if (optimizelyScript && optimizelyScript.type === 'text/plain' && typeof window.OnetrustActiveGroups !== 'undefined' && window.OnetrustActiveGroups.indexOf('C0003') > -1) {
                            var clonedScript = optimizelyScript.cloneNode(true);
                            clonedScript.type = 'text/javascript';
                            optimizelyScript.parentNode.insertBefore(clonedScript, optimizelyScript);
                            optimizelyScript.remove();
                        }
                    })();
                `}
            </Script>
            {!isWebView && (
                <Script src="https://resources.digital-cloud.medallia.eu/wdceu/204611/onsite/embed.js" async={true} />
            )}
            <link rel="dns-prefetch" href="//cdn.decibelinsight.net" />
            <link rel="dns-prefetch" href="//collection.decibelinsight.net" />
            {!isWebView && (
                <Script id="medallia-dxa">
                    {`
                // <![CDATA[
                    (function(d,e,c,i,b,el,it) {
                        d._da_=d._da_||[];_da_.oldErr=d.onerror;_da_.err=[];
                        d.onerror=function(){_da_.err.push(arguments);_da_.oldErr&&_da_.oldErr.apply(d,Array.prototype.slice.call(arguments));};
                        d.DecibelInsight=b;d[b]=d[b]||function(){(d[b].q=d[b].q||[]).push(arguments);};
                        el=e.createElement(c),it=e.getElementsByTagName(c)[0];el.async=1;el.src=i;it.parentNode.insertBefore(el,it);
                    })(window,document,'script','https://cdn.decibelinsight.net/i/14140/2391782/di.js','decibelInsight');
                // ]]>
                `}
                </Script>
            )}

            {/* Those GTM scripts have to go in <body> tag */}
            <noscript>
                {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
                <iframe
                    src={`https://www.googletagmanager.com/ns.html?id=${process.env.GTM_ID_1}`}
                    height="0"
                    width="0"
                    style={{ display: 'none', visibility: 'hidden' }}
                />
            </noscript>

            <noscript>
                {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
                <iframe
                    src={`https://www.googletagmanager.com/ns.html?id=${process.env.GTM_ID_2}`}
                    height="0"
                    width="0"
                    style={{ display: 'none', visibility: 'hidden' }}
                />
            </noscript>
        </>
    );
};
